export const meta = {
  title: 'Penjenamaan: nama anda di pintu, bukan nama kami',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'catalog'],
};

Aplikasi yang diimbas pelanggan anda ialah milik **anda** — nama anda, logo anda, warna anda. Nama kami hanya muncul sebagai satu baris kecil "sebahagian daripada rangkaian". Semua yang berkaitan jenama berada dalam tetapan penjenamaan anda, dan setiap simpanan terus dilihat pelanggan serta-merta.

## Nama aplikasi anda

Aplikasi pelanggan anda dinamakan sempena nama perniagaan yang anda daftarkan — itulah tajuk yang pelanggan nampak di skrin utama telefon apabila memasang aplikasi anda, dan nama pada setiap notifikasi. Versi pendek dijana secara automatik untuk ruang sempit seperti ikon Android.

## Logo anda

Muat naik logo anda dalam wizard alu-aluan dan kami uruskan kerja leceh: setiap saiz ikon untuk skrin utama Android dan iPhone, berserta skrin pembuka iOS, dijana secara automatik daripada satu fail itu. Selagi belum dimuat naik, pelanggan nampak imej sementara yang neutral.

Terlepas langkah wizard itu? Halaman muat naik semula logo di papan pemuka akan datang tidak lama lagi — buat masa ini, muat naik melalui wizard ialah satu-satunya jalan masuk.

## Warna dan fon

Aplikasi anda dilancarkan dengan palet lalai yang kemas dan tipografi sistem. Editor warna dan fon layan-diri sedang dalam perjalanan; ia belum ada di papan pemuka lagi.

## Waktu operasi

Buka **Waktu** dari pengepala papan giliran. Halaman ini menentukan apa yang pelanggan nampak di skrin utama mereka dan sama ada mereka boleh menempah:

- **Waktu mingguan** — setiap hari ada togol buka/tutup dan waktunya sendiri. Dua pintasan menjimatkan taipan: **Salin hari bekerja → hujung minggu** dan **Terapkan 9–6 ke semua**.
- **Status hari ini** — pil pratonton langsung di bahagian atas (_Buka sekarang_, _Buka nanti_, _Tutup hari ini_, dan sebagainya) menunjukkan tepat apa yang pelanggan sedang lihat, dikemas kini sambil anda mengedit, sebelum anda menyimpan pun.

Pelanggan yang membuka aplikasi anda semasa anda tutup akan nampak dengan jelas — dan tempahan disekat sehingga anda buka semula, jadi tiada siapa masuk barisan yang tiada siapa mencuci.

## Penggantian cuti

Cuti umum? Tekan **+ Tambah cuti**, pilih tarikh, dan tandakan tutup — atau berikan waktu khas. Label pilihan ("Hari Raya") memberitahu pelanggan sebabnya. Penggantian mengatasi jadual mingguan pada tarikhnya sahaja.

## Penutupan sementara

Ubah suai kedai, atau bercuti seminggu? Aktifkan **Tutup untuk tempoh tertentu**, tetapkan julat tarikh, dan tulis mesej yang pelanggan akan baca — contohnya, _"Tutup sempena Hari Raya — kembali pada 15 haribulan."_ Sepanjang tempoh itu, ia mengatasi waktu mingguan dan penggantian cuti, dan aplikasi pelanggan anda memaparkan sepanduk itu di setiap skrin penting.

## Suis direktori awam

Di bahagian bawah halaman Waktu ada **Papar outlet saya di direktori awam**. Apabila dihidupkan, outlet aktif anda muncul di halaman carian awam rangkaian — nama, gambar, waktu operasi, dan tempoh menunggu langsung — dan pemandu yang melayarinya boleh terus masuk ke aplikasi anda. Ia dimatikan secara lalai: tiada siapa disenaraikan tanpa menghidupkannya sendiri. Matikan bila-bila masa untuk hilang daripada direktori; aplikasi dan QR anda sendiri terus berfungsi seperti biasa.

## Perubahan terus berkuat kuasa

Setiap simpanan menaikkan versi penjenamaan anda, dan aplikasi pelanggan menerima perubahan pada bukaan seterusnya — waktu baharu, logo baharu, sepanduk penutupan baharu. Tiada ritual kosongkan cache, tiada apa yang perlu pelanggan pasang semula.
